// extracted by mini-css-extract-plugin
export default {"form-container":"CommentForm_form-container__IgGdQ","input-comment":"CommentForm_input-comment__1cYLy","btn":"CommentForm_btn__lUdL9"};